//#region aitisal-sdk.ts
var AitisalSdk = class AitisalSdk {
	constructor(axiosInstance) {
		this.axiosInstance = axiosInstance;
	}
	static configure(axiosInstance) {
		if (!AitisalSdk.instance) AitisalSdk.instance = new AitisalSdk(axiosInstance);
	}
	static getInstance() {
		if (!AitisalSdk.instance) throw new Error("SDK not initialized, please use the configure method to initialize the SDK");
		return AitisalSdk.instance;
	}
	async get(url, config) {
		return this.axiosInstance.get(url, config);
	}
	async post(url, data, config) {
		return this.axiosInstance.post(url, data, config);
	}
	async put(url, data, config) {
		return this.axiosInstance.put(url, data, config);
	}
	async patch(url, data, config) {
		return this.axiosInstance.patch(url, data, config);
	}
	async delete(url, config) {
		return this.axiosInstance.delete(url, config);
	}
};

//#endregion
export { AitisalSdk as t };
//# sourceMappingURL=aitisal-sdk-B2mK3RTK.mjs.map